<div class="sign-up-flow">
    <div class="sign-up-flow__backdrop" aria-hidden="true"></div>

    <div class="sign-up-flow__card">
        <img class="sign-up-flow__logo" src="./assets/images/logos/login-logo.png" alt="COMMITLY" width="134" height="35"/>

        <ng-template #backLink>
            <button type="button" class="sign-up-flow__back" (click)="goBack()">
                <span class="iconsax iconsax-blue" [iconName]="'arrow-left'"></span>
                {{'Setup.Buttons.Back' | translate}}
            </button>
        </ng-template>

        <ng-template #errorSummary>
            <div class="sign-up-flow__error-summary" [hidden]="!(errors.length > 0)">
                <span class="sign-up-flow__error" *ngFor="let error of errors">{{error | async}}</span>
            </div>
        </ng-template>

        <p class="sign-up-flow__heading" *ngIf="currentStep !== signUpStep.Confirmation">
            {{'SignUp.Step.Heading' | translate}}
        </p>

        <ng-container [ngSwitch]="currentStep">

            <ng-container *ngSwitchCase="signUpStep.Email">
                <ul class="sign-up-flow__benefits">
                    <li>
                        <span class="iconsax iconsax-green" iconName="tick-circle"></span>
                        {{'SignUp.Step.Benefit1' | translate}}
                    </li>
                    <li>
                        <span class="iconsax iconsax-green" iconName="tick-circle"></span>
                        {{'SignUp.Step.Benefit2' | translate}}
                    </li>
                    <li>
                        <span class="iconsax iconsax-green" iconName="tick-circle"></span>
                        {{'SignUp.Step.Benefit3' | translate}}
                    </li>
                </ul>
                <div class="sign-up-flow__row">
                    <div class="sign-up-flow__field">
                        <app-input-line-form
                            appAutofocus
                            [control]="emailCtrl"
                            [submitted]="submitPressed"
                            [type]="'email'"
                            [placeholder]="'SignUp.Form.EmailPlaceholder' | translate"
                            [tabindex]="1"
                            [autocomplete]="'email'"
                        ></app-input-line-form>
                        <ng-container *ngTemplateOutlet="errorSummary"></ng-container>
                    </div>
                    <ui-text-button
                        class="sign-up-flow__submit"
                        [buttonStyle]="buttonStyle.Green"
                        (click)="submitEmailStep()"
                        [disabled]="submitInFlight || (submitPressed && emailCtrl.invalid)"
                        data-test-id="sign-up-page-email-submit"
                    >
                        {{'SignUp.Step.TryForFree' | translate}}
                    </ui-text-button>
                </div>
                <div class="sign-up-flow__footer">
                    <p class="sign-up-flow__legal">
                        {{'SignUp.Step.LegalTextPrefix' | translate}}
                        <a href="https://commitly.com/agb" target="_blank" rel="noreferrer">{{'SignUp.Form.TermsOfService' | translate}}</a>
                        {{'SignUp.Form.And' | translate}}
                        <a href="https://commitly.com/datenschutzerklarung" target="_blank" rel="noreferrer">{{'SignUp.Form.DataPrivacy' | translate}}</a>
                        {{'SignUp.Step.LegalTextSuffix' | translate}}
                    </p>
                    <div class="sign-up-flow__divider"></div>
                    <div class="sign-up-flow__signin">
                        <span>{{'SignUp.AlreadyHaveAccount' | translate}}</span>
                        <a [uiSref]="signInState">
                            {{'SignUp.SignIn' | translate}}
                            <span class="iconsax iconsax-blue" [iconName]="'arrow-right'"></span>
                        </a>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngSwitchCase="signUpStep.Name">
                <div class="sign-up-flow__names">
                    <ng-container *ngTemplateOutlet="backLink"></ng-container>
                    <p class="sign-up-flow__subheading">{{'SignUp.Step.NameHeading' | translate}}</p>
                    <div class="sign-up-flow__inline-row">
                        <div class="sign-up-flow__field">
                            <div class="sign-up-flow__names-row">
                                <app-input-line-form
                                    appAutofocus
                                    [control]="firstNameCtrl"
                                    [submitted]="submitPressed"
                                    [placeholder]="'SignUp.Form.FirstNamePlaceholder' | translate"
                                    [tabindex]="1"
                                ></app-input-line-form>
                                <app-input-line-form
                                    [control]="lastNameCtrl"
                                    [submitted]="submitPressed"
                                    [placeholder]="'SignUp.Form.LastNamePlaceholder' | translate"
                                    [tabindex]="2"
                                ></app-input-line-form>
                            </div>
                            <span
                                class="sign-up-flow__error"
                                *ngIf="submitPressed && (firstNameCtrl.hasError('maxlength') || lastNameCtrl.hasError('maxlength'))"
                            >
                                {{'SignUp.Form.NameLengthWarning' | translate}}
                            </span>
                        </div>
                        <ui-text-button
                            class="sign-up-flow__submit"
                            [buttonStyle]="buttonStyle.Green"
                            (click)="signUp()"
                            [disabled]="submitInFlight || !nameStepReady"
                            data-test-id="sign-up-page-name-submit"
                        >
                            {{'SignUp.Step.Next' | translate}}
                        </ui-text-button>
                    </div>
                    <div class="sign-up-flow__field">
                        <div class="sign-up-flow__terms">
                            <ui-check-box
                                [tabindex]="3"
                                [formControl]="agreeToTermsCtrl"
                                [invalid]="submitPressed && agreeToTermsCtrl.hasError('agreeToTerms')"
                            ></ui-check-box>
                            <span class="sign-up-flow__terms-label">
                                {{'SignUp.Form.AgreeTo' | translate}}
                                <a href="https://commitly.com/agb" target="_blank" rel="noreferrer">{{'SignUp.Form.TermsOfService' | translate}}</a>
                                {{'SignUp.Form.And' | translate}}
                                <a href="https://commitly.com/datenschutzerklarung" target="_blank" rel="noreferrer">{{'SignUp.Form.DataPrivacy' | translate}}</a>
                            </span>
                        </div>
                        <div
                            class="sign-up-flow__error"
                            *ngIf="submitPressed && agreeToTermsCtrl.hasError('agreeToTerms')"
                        >
                            {{'SignUp.Form.ErrorAgreeToTerms' | translate}}
                        </div>
                        <ng-container *ngTemplateOutlet="errorSummary"></ng-container>
                    </div>
                    <p class="sign-up-flow__hint">{{'SignUp.Step.NameHint' | translate}}</p>
                </div>
                <div class="sign-up-flow__footer">
                    <div class="sign-up-flow__divider"></div>
                    <div class="sign-up-flow__note">{{'SignUp.Step.Step2Footer' | translate}}</div>
                </div>
            </ng-container>

            <ng-container *ngSwitchCase="signUpStep.Confirmation">
                <div class="sign-up-flow__confirmation">
                    <div class="sign-up-flow__confirmation-icon">
                        <span class="iconsax iconsax-white" iconName="mail" aria-hidden="true"></span>
                        <span class="iconsax iconsax-green sign-up-flow__confirmation-icon__check" iconName="tick-circle" aria-hidden="true"></span>
                    </div>
                    <p class="sign-up-flow__heading">{{'SignUp.SignUpSuccessTitle' | translate}} 🚀</p>
                    <p class="sign-up-flow__subheading">{{'SignUp.SignUpSuccessSubTitle' | translate}}</p>
                    <p class="sign-up-flow__sent">{{'SignUp.SignUpSuccessText' | translate}}</p>
                    <div class="sign-up-flow__email">
                        <span class="iconsax" [iconName]="'mail'"></span>
                        <span>{{emailCtrl.value}}</span>
                    </div>
                    <p class="sign-up-flow__text" [innerHTML]="'SignUp.SignUpSuccessTextDetail' | translate | safeHtml"></p>
                </div>
                <div class="sign-up-flow__divider"></div>
                <p class="sign-up-flow__spam">{{'SignUp.SignUpSuccessSpamText' | translate}}</p>
            </ng-container>

        </ng-container>
    </div>
</div>
